import React from 'react';

import { Alert, AlertDescription } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { REBRANDING_GUIDE_URL } from 'app/developer-v3/constants';
import { useRouter } from 'app/developer-v3/hooks';

const CtaPublicIntegration = () => {
  const { params } = useRouter();
  const url = new URL(REBRANDING_GUIDE_URL);
  url.searchParams.set('app_id', params.id);

  return (
    <Alert
      status="warning"
      title="You can’t edit settings for this integration."
    >
      <AlertDescription>
        To edit your integration details on Zapier's public app directory,
        please submit{' '}
        <Link href={url.href} target="_blank">
          this form
        </Link>
        .
      </AlertDescription>
    </Alert>
  );
};

export default CtaPublicIntegration;
